import { isNavigationFailure } from 'vue-router';
import app from '@/app-instance';

const noop = () => {};

export default {
  namespaced: true,
  state: {
    requestsCount: 0,
  },
  getters: {
    isLoading(state) {
      return state.requestsCount > 0;
    },
  },
  mutations: {
    incRequestCount(state, value = 1) {
      state.requestsCount += value;
    },
  },
  actions: {
    request({ commit }) {
      commit('incRequestCount');
    },
    response({ commit }) {
      commit('incRequestCount', -1);
    },
    unhandledError({ dispatch, rootGetters }, error) {
      const message = { type: 'danger', textKey: '', delay: 5000 };
      const handleError = app.config.errorHandler || noop;
      const handleWarning = app.config.warnHandler || noop;

      if (error.response) {
        const { data: payload, status } = error.response;
        const isProcessableStatus = status === 400 || status > 401 && status < 500;

        if (status === 401) {
          if (rootGetters['session/isLoggedIn']) {
            message.type = 'info';
            message.textKey = 'errors.sessionExpired';
            dispatch('session/expired', null, { root: true });
          } else {
            message.type = 'info';
            message.textKey = 'errors.notLoggedIn';
          }
        } else {
          if (payload.message && isProcessableStatus) {
            message.text = payload.message;
          } else {
            message.textKey = `errors.${isProcessableStatus ? 'invalidPayload' : 'serverError'}`;
          }

          handleError(error);
        }
      } else {
        message.textKey = `errors.${error.request ? 'networkUnavailable' : 'appError'}`;
        handleError(error);

        if (isNavigationFailure(error)) {
          // Do not notify user about navigation failures
          // but keep a record of this in Sentry and notify developer in console via warning
          handleWarning(error); // eslint-disable-line no-console
          return;
        }
      }

      dispatch('alerts/notify', message, { root: true });
    },
    findPersonByCode({ rootGetters }, code) {
      return rootGetters.api.get(`/persons/${code}`)
        .then((response) => response.data);
    },
    sendQuestion({ rootGetters }, params) {
      return rootGetters.api.post('/feedback', params)
        .then((response) => response.data);
    },
    sendStep({ rootGetters }, params) {
      return rootGetters.api.post('/pd/log-step', params)
        .then((response) => response.data);
    },
  },
};
